import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EmergencyContactsOverviewBaseComponent } from '@resident-nx/shared';
import { ContactDetailsWebComponent } from '../contact-details/contact-details.component';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { CardsContainerHeaderWebComponent } from '../../molecules/cards-container-header/cards-container-header.component';
import { LoaderWebComponent, IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-emergency-contacts-overview',
  templateUrl: './emergency-contacts-overview.component.html',
  styleUrls: ['./emergency-contacts-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContactDetailsWebComponent,
    LoaderWebComponent,
    CardsContainerHeaderWebComponent,
    TranslateModule,
    AsyncPipe,
    IconWebComponent,
    NgbAccordionModule,
  ],
})
export class EmergencyContactsOverviewWebComponent extends EmergencyContactsOverviewBaseComponent {}
